module.exports = __webpack_public_path__ + "build/desktop/a/img/residence-icon.49a3baa2bd403163be9c37d343d42d54.svg";